import React from 'react';

export default function Blocks() {
  return (
    <svg
      width='42'
      height='41'
      viewBox='0 0 42 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_931_9538)'>
        <g clipPath='url(#clip0_931_9538)'>
          <rect
            x='1'
            width='40'
            height='40'
            rx='12'
            fill='url(#paint0_linear_931_9538)'
          />
          <g clipPath='url(#clip1_931_9538)' filter='url(#filter1_dd_931_9538)'>
            <path
              d='M30.4995 17.479V11.5H24.5205L20.9995 7.979L17.4785 11.5H12.4995V16.479L8.97852 20L12.4995 23.521V28.5H17.4785L20.9995 32.021L24.5205 28.5H29.4995V23.521L33.0205 20L30.4995 17.479ZM21.0985 23.442C20.7425 23.799 20.2625 23.999 19.7515 24C19.2405 24 18.7615 23.801 18.3995 23.438L14.7975 19.895L16.1995 18.47L19.7505 21.961L26.8985 14.888L28.3085 16.307L21.0995 23.442H21.0985Z'
              fill='url(#paint1_linear_931_9538)'
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_di_931_9538'
          x='0.5'
          y='0'
          width='41'
          height='41'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_931_9538'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_931_9538'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='0.5' />
          <feGaussianBlur stdDeviation='0.25' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_931_9538'
          />
        </filter>
        <filter
          id='filter1_dd_931_9538'
          x='-21'
          y='-18.1015'
          width='84'
          height='84'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='10' />
          <feGaussianBlur stdDeviation='10' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_931_9538'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='3.89851' />
          <feGaussianBlur stdDeviation='15' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_931_9538'
            result='effect2_dropShadow_931_9538'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_931_9538'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_931_9538'
          x1='21'
          y1='0'
          x2='21'
          y2='40'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#29282C' />
          <stop offset='1' stopColor='#100F11' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_931_9538'
          x1='8.79276'
          y1='3.03916'
          x2='26.2455'
          y2='28.6206'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
        <clipPath id='clip0_931_9538'>
          <rect x='1' width='40' height='40' rx='12' fill='white' />
        </clipPath>
        <clipPath id='clip1_931_9538'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(9 8)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
